module.exports = __webpack_public_path__ + "media/03_ASANBUDAPEST-BEATS03.dbb5ae17.mp3";